import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2bb100be"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Plazas restantes:", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Fin entrega de listas:", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Fin de inscripción:", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Pagos:", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Listas entregadas:", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Listas legales:", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Listas de luz:", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Listas de oscuridad:", -1))
const _hoisted_9 = {
  key: 0,
  style: {"margin-top":"10px"}
}
const _hoisted_10 = { style: {"text-align":"center","font-size":"12px","margin-top":"4px"} }

import { esUsuarioBye } from "@/utils/bye";
import { computed, ref } from "vue";
import { TorneoGestionInfoMasDTO, Torneo } from "@/interfaces/Torneo";
import { getListasTorneoAsync, getTorneo } from "@/services/TorneosService";
import ModalSuccess from "@/components/Commons/ModalSuccess.vue";
import ModalError from "@/components/Commons/ModalError.vue";
import ModalModificarBasesTorneo from "../ModalModificarBasesTorneo.vue";
import ModalModificarTorneo from "../ModalModificarTorneo.vue";
import ModalHandlerMostrarListas from "../ModalHandlerMostrarListas.vue";
import ModalHandlerMostrarClasificacion from "../ModalHandlerMostrarClasificacion.vue";
import LoadingLOTR from "@/components/Commons/LoadingLOTR.vue";
import { ListaCompletaDTO } from "@/interfaces/Lista";
import jsPDF from "jspdf";
import { ArchivoParaEntregar, entregarArchivos } from "@/utils/entregarArchivos";
import CardAddTorneoCircuito from "../CardAddTorneoCircuito.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CardGestionTorneoMas',
  props: {
    torneo: {}
  },
  setup(__props: any) {

const progressPDF = ref<number>(0);

// eslint-disable-next-line no-undef
const props = __props;
const showErrorModal = ref<boolean>(false);
const showSuccessModal = ref<boolean>(false);
const showModificarTorneoModal = ref<boolean>(false);
const showModificarBasesTorneoModal = ref<boolean>(false);

const idTorneo = ref<number>(0);
const torneoMod = ref<Torneo>(); // Define adecuadamente el tipo de `torneoMod`
const showModalHandlerMostrarListas = ref<boolean>(false);
const showModalHandlerMostrarClasificacion = ref<boolean>(false);

const mostrarListas = ref(props.torneo?.torneo.mostrarListas);
const mostrarClasificacion = ref(props.torneo?.torneo.mostrarClasificacion);
const isLoading = ref<boolean>(false);
const isDownloading = ref<boolean>(false);

// Las cifras, sin el bye: no es nadie a quien contar ni reclamar
const inscritos = computed(() =>
  (props.torneo?.inscripciones ?? []).filter(i => !esUsuarioBye(i.idUsuario, i.nick))
);

const plazasRestantes = computed(() => {
  if (!props.torneo || inscritos.value.length === null) {
    return "Sin límite";
  }
  if (props.torneo.torneo.limiteParticipantes == null) return "Sin límite";
  return (
    props.torneo.torneo.limiteParticipantes - inscritos.value.length
  );
});

const todasLasListas = computed(() => {
  if (!props.torneo || !inscritos.value) return [];

  return inscritos.value.flatMap(inscripcion => inscripcion.lista);
});

const listasTotales = computed(() => {
  if (!props.torneo) return 0;
  return (
    props.torneo.torneo.listasPorJugador * inscritos.value.length
  );
});

const listasLuz = computed(() => {
  if (!props.torneo) return 0;
  return todasLasListas.value.filter(l => l.bando === "good").length;
});

const listasOscuridad = computed(() => {
  if (!props.torneo) return 0;
  return todasLasListas.value.filter(l => l.bando === "evil").length;
});

const totalInscripciones = computed(() => {
  return props.torneo ? inscritos.value.length : 0;
});

const pagosRealizados = computed(() => {
  if (!props.torneo) return 0;
  return inscritos.value.filter(
    inscripcion => inscripcion.esPago === "SI"
  ).length;
});

const listasLegales = computed(() => {
  if (!props.torneo) return 0;
  return todasLasListas.value.filter(l => l.estadoLista == "OK").length;
});

const listasEntregadas = computed(() => {
  if (!props.torneo) return 0;
  return todasLasListas.value.filter(
    l =>
      l.estadoLista == "ENTREGADA" ||
      l.estadoLista === "ILEGAL" ||
      l.estadoLista === "OK"
  ).length;
});

const formatDate = (date: string | null | undefined) => {
  if (!date) return "N/A";
  return new Date(date).toLocaleDateString();
};

const modificarTorneo = async () => {
  if (props.torneo?.torneo.idTorneo != undefined) {
    idTorneo.value = props.torneo?.torneo.idTorneo;

    try {
      const responseTorneo = await getTorneo(idTorneo.value);
      torneoMod.value = responseTorneo.data;
      showModificarTorneoModal.value = true;
    } catch (error) {
      console.error(error);
      showErrorModal.value = true;
    }
  }
};

const modificarBasesTorneo = async () => {
  if (props.torneo?.torneo.idTorneo != undefined) {
    idTorneo.value = props.torneo?.torneo.idTorneo;

    try {
      const responseTorneo = await getTorneo(idTorneo.value);
      torneoMod.value = responseTorneo.data;
      showModificarBasesTorneoModal.value = true;
    } catch (error) {
      console.error(error);
      showErrorModal.value = true;
    }
  }
};

const cerrarModal = () => {
  showModificarBasesTorneoModal.value = false;
  showModalHandlerMostrarListas.value = false;
  showModalHandlerMostrarClasificacion.value = false;

  showModificarTorneoModal.value = false;
};

const handlerMostrarListas = async () => {
  if (
    props.torneo?.torneo.idTorneo != undefined &&
    props.torneo?.torneo.idTorneo != 0 &&
    props.torneo?.torneo.idTorneo != null
  )
    idTorneo.value = props.torneo?.torneo.idTorneo;

  try {
    const responseTorneo = await getTorneo(idTorneo.value);
    torneoMod.value = responseTorneo.data;
    showModalHandlerMostrarListas.value = true;
  } catch (error) {
    console.error(error);
    showErrorModal.value = true;
  } finally {
    isLoading.value = false;
    showErrorModal.value = false;
  }
};

const onCambioMostrarListas = (nuevoValor: boolean) => {
  mostrarListas.value = nuevoValor;
  showModalHandlerMostrarListas.value = false;
};

const handlerMostrarClasificacion = async () => {
  if (
    props.torneo?.torneo.idTorneo != undefined &&
    props.torneo?.torneo.idTorneo != 0 &&
    props.torneo?.torneo.idTorneo != null
  )
    idTorneo.value = props.torneo?.torneo.idTorneo;

  try {
    const responseTorneo = await getTorneo(idTorneo.value);
    torneoMod.value = responseTorneo.data;
    showModalHandlerMostrarClasificacion.value = true;
  } catch (error) {
    console.error(error);
    showErrorModal.value = true;
  } finally {
    isLoading.value = false;
    showErrorModal.value = false;
  }
};

function chunkArray<T>(arr: T[], size: number): T[][] {
  const result: T[][] = [];
  for (let i = 0; i < arr.length; i += size) {
    result.push(arr.slice(i, i + size));
  }
  return result;
}

const descargarListasTorneo = async () => {
  if (
    props.torneo?.torneo.idTorneo != undefined &&
    props.torneo?.torneo.idTorneo != 0 &&
    props.torneo?.torneo.idTorneo != null
  )
    idTorneo.value = props.torneo?.torneo.idTorneo;

  try {
    isDownloading.value = true;
    const response = await getListasTorneoAsync(idTorneo.value);
    const listas: ListaCompletaDTO[] = response.data;
    const chunkedListas = chunkArray(listas, 40);
    const total = chunkedListas.reduce((acc, arr) => acc + arr.length, 0);
    let processed = 0;
    const archivos: ArchivoParaEntregar[] = [];
    for (let i = 0; i < chunkedListas.length; i++) {
      const doc = new jsPDF();
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      let y = 10;
      for (let idx = 0; idx < chunkedListas[i].length; idx++) {
        const lista = chunkedListas[i][idx];
        if (lista.listaData) {
          const imgMatch = lista.listaData.match(
            /^data:image\/(png|jpeg|jpg);base64,/
          );
          if (imgMatch) {
            if (idx !== 0) doc.addPage();

            doc.setFontSize(18);
            doc.text(`${lista.nick}`, pageWidth / 2, 20, { align: "center" });

            const margin = 15;
            const imgProps = doc.getImageProperties(lista.listaData);
            let imgWidth = pageWidth - margin * 2;
            let imgHeight = (imgProps.height * imgWidth) / imgProps.width;
            if (imgHeight > pageHeight - 40 - margin) {
              imgHeight = pageHeight - 40 - margin;
              imgWidth = (imgProps.width * imgHeight) / imgProps.height;
            }
            const x = (pageWidth - imgWidth) / 2;
            const yImg = 30;
            doc.addImage(
              lista.listaData,
              imgMatch[1],
              x,
              yImg,
              imgWidth,
              imgHeight
            );
          } else {
            doc.text(`${lista.nick}`, 10, y);
            y += 10;
            const lines = doc.splitTextToSize(lista.listaData, 180);
            doc.text(lines, 10, y);
            y += lines.length * 7;
            doc.line(10, y, 200, y); // separador
            y += 10;
            if (y > 270 && idx < chunkedListas[i].length - 1) {
              doc.addPage();
              y = 10;
            }
          }
        } else {
          doc.text(`${lista.nick}`, 10, y);
          y += 10;
        }
        processed++;
        progressPDF.value = Math.round((processed / total) * 100);
        await new Promise(resolve => setTimeout(resolve, 0));
      }
      const baseName = props.torneo?.torneo.nombreTorneo
        ? props.torneo?.torneo.nombreTorneo + "_listas"
        : "listas_torneo";
      const fileName =
        chunkedListas.length > 1
          ? `${baseName}_${i + 1}.pdf`
          : `${baseName}.pdf`;
      archivos.push({ blob: doc.output("blob"), nombre: fileName });
    }
    await entregarArchivos(archivos);
  } catch (error) {
    console.error(error);
    showErrorModal.value = true;
  } finally {
    progressPDF.value = 0;
    isDownloading.value = false;
    showErrorModal.value = false;
  }
};

const onCambioMostrarClasificacion = (nuevoValor: boolean) => {
  mostrarClasificacion.value = nuevoValor;
  showModalHandlerMostrarClasificacion.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.torneo)
      ? (_openBlock(), _createBlock(_component_v_card, {
          key: 0,
          class: "mb-4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.torneo.torneo.nombreTorneo), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createElementVNode("p", null, [
                  _hoisted_1,
                  _createTextVNode(" " + _toDisplayString(plazasRestantes.value), 1)
                ]),
                _createElementVNode("p", null, [
                  _hoisted_2,
                  _createTextVNode(" " + _toDisplayString(formatDate(_ctx.torneo.torneo.fechaEntregaListas)), 1)
                ]),
                _createElementVNode("p", null, [
                  _hoisted_3,
                  _createTextVNode(" " + _toDisplayString(formatDate(_ctx.torneo.torneo.fechaFinInscripcion)), 1)
                ]),
                _createElementVNode("p", null, [
                  _hoisted_4,
                  _createTextVNode(" " + _toDisplayString(pagosRealizados.value) + "/" + _toDisplayString(totalInscripciones.value), 1)
                ]),
                _createElementVNode("p", null, [
                  _hoisted_5,
                  _createTextVNode(" " + _toDisplayString(listasEntregadas.value) + "/" + _toDisplayString(listasTotales.value), 1)
                ]),
                _createElementVNode("p", null, [
                  _hoisted_6,
                  _createTextVNode(" " + _toDisplayString(listasLegales.value) + "/" + _toDisplayString(listasTotales.value), 1)
                ]),
                _createElementVNode("p", null, [
                  _hoisted_7,
                  _createTextVNode(" " + _toDisplayString(listasLuz.value), 1)
                ]),
                _createElementVNode("p", null, [
                  _hoisted_8,
                  _createTextVNode(" " + _toDisplayString(listasOscuridad.value), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          variant: "tonal",
                          color: "secondary",
                          block: "",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (modificarTorneo()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Modificar torneo")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          variant: "tonal",
                          color: "secondary",
                          block: "",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (modificarBasesTorneo()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Modificar bases")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          variant: "tonal",
                          color: "secondary",
                          block: "",
                          onClick: handlerMostrarListas
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(mostrarListas.value ? "Ocultar" : "Mostrar") + " Listas ", 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          variant: "tonal",
                          color: "secondary",
                          block: "",
                          onClick: handlerMostrarClasificacion
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(mostrarClasificacion.value ? "Ocultar" : "Mostrar") + " Clasificación ", 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          variant: "tonal",
                          color: "secondary",
                          block: "",
                          onClick: descargarListasTorneo
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Descargar Listas")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _renderSlot(_ctx.$slots, "acciones")
                  ]),
                  _: 3
                })
              ]),
              _: 3
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(CardAddTorneoCircuito, {
                  idTorneo: props.torneo?.torneo.idTorneo!
                }, null, 8, ["idTorneo"])
              ]),
              _: 1
            })
          ]),
          _: 3
        }))
      : _createCommentVNode("", true),
    _createVNode(ModalModificarTorneo, {
      isVisible: showModificarTorneoModal.value,
      torneo: torneoMod.value,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (cerrarModal()))
    }, null, 8, ["isVisible", "torneo"]),
    _createVNode(ModalModificarBasesTorneo, {
      isVisible: showModificarBasesTorneoModal.value,
      torneo: torneoMod.value,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (cerrarModal()))
    }, null, 8, ["isVisible", "torneo"]),
    _createVNode(ModalHandlerMostrarListas, {
      isVisible: showModalHandlerMostrarListas.value,
      torneo: torneoMod.value,
      onClose: _cache[4] || (_cache[4] = ($event: any) => (cerrarModal())),
      onConfirm: onCambioMostrarListas
    }, null, 8, ["isVisible", "torneo"]),
    _createVNode(ModalHandlerMostrarClasificacion, {
      isVisible: showModalHandlerMostrarClasificacion.value,
      torneo: torneoMod.value,
      onClose: _cache[5] || (_cache[5] = ($event: any) => (cerrarModal())),
      onConfirm: onCambioMostrarClasificacion
    }, null, 8, ["isVisible", "torneo"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessModal.value,
      message: "Torneo modificado con éxito.",
      "onUpdate:isVisible": _cache[6] || (_cache[6] = ($event: any) => (showSuccessModal.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalError, {
      isVisible: showErrorModal.value,
      message: "No se han podido modificar el torneo. Intentalo de nuevo y si el error persiste contacta con el administrador.",
      "onUpdate:isVisible": _cache[7] || (_cache[7] = ($event: any) => (showErrorModal.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(LoadingLOTR, {
      isVisible: isDownloading.value,
      mensaje: "Generando PDF, por favor espera..."
    }, {
      default: _withCtx(() => [
        (isDownloading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(progressPDF.value) + "% ", 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["isVisible"])
  ], 64))
}
}

})